// 地址監控頁面翻譯
export default {
  // 輸入框占位符
  placeholders: {
    monitorName: "請輸入監控名稱",
    monitorAddress: "請輸入監控地址",
    selectCurrency: "請選擇幣種",
  },

  // 按鈕
  buttons: {
    reset: "重置",
    search: "查詢",
    addMonitor: "+ 添加監控",
    view: "查看",
    edit: "修改",
  },

  // 標題和統計
  statistics: {
    totalMonitors: "條地址監控",
    monitoring: "監控中",
    total: "共",
    count: "條",
  },

  // 監控類型
  monitorTypes: {
    common: "普通監控",
    realtime: "實時監控",
  },

  // 監控狀態
  status: {
    enable: "監控中",
    pause: "已暫停",
  },

  // 監控信息
  monitorInfo: {
    monitorName: "監控名稱",
    address: "地址",
    relatedCase: "關聯案件",
    condition: "條件",
    remark: "備註",
    dynamics: "條監控動態",
    unread: "條未讀",
  },

  // 對話框
  dialogs: {
    title: "提示",
    addMonitor: "添加監控",
    edit: "修改",
    deleteConfirm: "此操作將永久刪除該文件, 是否繼續?",
    changeStatusConfirm: "是否變更狀態為",
    openMonitor: "打開監控",
    closeMonitor: "關閉監控",
    dingTalkHelp: "釘釘添加機器人操作說明",
  },

  // 詳情抽屜
  details: {
    title: "詳情",
    transferIn: "轉入",
    transferOut: "轉出",
    amount: "金額",
    address: "地址",
    hash: "hash",
    time: "時間",
  },

  // 提示信息
  messages: {
    noData: "暫無數據",
    deleteSuccess: "刪除監控成功",
    deleteCancelled: "已取消刪除",
    editSuccess: "修改成功",
    closeSuccess: "關閉成功",
    copySuccess: "複製成功",
    loading: "拼命加載中",
  },

  // 確認按鈕
  confirm: {
    yes: "是",
    no: "否",
    ok: "確定",
    cancel: "取消",
  },
};
